<section class="legal-page">
  <div class="legal-title-strip">
    <h1>{{ appModeService.isApp() ? ('FOOTER.TERMS' | translate) : 'Terms & Conditions' }}</h1>
  </div>

  <article class="legal-content" [innerHTML]="content"></article>

  <div class="legal-actions">
    <button class="read-more-btn" (click)="navigateToShop()">{{ 'VISIT_STORE' | translate }}</button>
  </div>
</section>
